import {
  getCreationProcessDisplayedName,
  getInternalMaterialProductComponentLabel,
  MaterialProductInfoListItem,
  MaterialProductValueType,
} from 'api';
import { getCountryNameByCountryAbbr } from 'form';
import { capitalizeString, DataGridColumn } from 'ui';

const NOT_SPECIFIED = 'N/A';

export const columns: DataGridColumn<MaterialProductInfoListItem>[] = [
  {
    columnSize: 'small',
    field: 'id',
    filterable: false,
    headerName: 'ID',
    sortable: false,
    valueGetter: (params) => {
      return params.row?.id;
    },
  },
  {
    columnSize: 'medium',
    field: 'country',
    filterable: false,
    headerName: 'Country',
    sortable: false,
    valueGetter: (params) => {
      return getCountryNameByCountryAbbr(params.row?.country);
    },
  },
  {
    columnSize: 'xLarge',
    field: 'material_spec',
    filterable: false,
    headerName: 'Material spec',
    sortable: false,
    valueGetter: (params) => {
      return params.row?.material_spec.title;
    },
  },
  {
    columnSize: 'small',
    field: 'material_grade',
    filterable: true,
    headerName: 'Material grade',
    sortable: false,
    type: 'string',
    valueGetter: (params) => {
      return params.row?.material_grade.name;
    },
  },
  {
    columnSize: 'medium',
    field: 'material_origin',
    filterable: false,
    headerName: 'Material origin',
    sortable: false,
    valueGetter: (params) => {
      return capitalizeString(params.row?.material_origin?.type || '') || NOT_SPECIFIED;
    },
  },
  {
    columnSize: 'small',
    field: 'creation_process',
    filterable: false,
    headerName: 'Process',
    sortable: false,
    valueGetter: (params) => {
      if (params.row?.creation_process) {
        return getCreationProcessDisplayedName(params.row?.creation_process);
      }
      return NOT_SPECIFIED;
    },
  },
  {
    columnSize: 'small',
    field: 'is_food_grade',
    filterable: false,
    headerName: 'Food grade',
    sortable: false,
    valueGetter: (params) => {
      if (params.row?.is_food_grade !== null) {
        return params.row?.is_food_grade ? 'Yes' : 'No';
      }
      return NOT_SPECIFIED;
    },
  },
  {
    columnSize: 'small',
    field: 'has_caps_and_labels',
    filterable: false,
    headerName: 'Caps and labels',
    sortable: false,
    valueGetter: (params) => {
      if (params.row?.has_caps_and_labels !== null) {
        return params.row?.has_caps_and_labels ? 'Yes' : 'No';
      }
      return NOT_SPECIFIED;
    },
  },
  {
    columnSize: 'large',
    field: 'seller_material_component_values',
    filterable: false,
    headerName: 'Seller Material Components',
    sortable: false,
    valueGetter: (params) => {
      if (params.row?.material_component_values) {
        return params.row?.material_component_values
          .filter((materialComponentValue) => materialComponentValue.type === MaterialProductValueType.SELLER)
          .map((materialComponentValue) => getInternalMaterialProductComponentLabel(materialComponentValue))
          .join(', ');
      }
      return NOT_SPECIFIED;
    },
  },
  {
    columnSize: 'large',
    field: 'buyer_material_component_values',
    filterable: false,
    headerName: 'Buyer Material Components',
    sortable: false,
    valueGetter: (params) => {
      if (params.row?.material_component_values) {
        return params.row?.material_component_values
          .filter((materialComponentValue) => materialComponentValue.type === MaterialProductValueType.BUYER)
          .map((materialComponentValue) => getInternalMaterialProductComponentLabel(materialComponentValue))
          .join(', ');
      }
      return NOT_SPECIFIED;
    },
  },
];
